











import ripple from "./ripple.vue";
import { Component, Vue, Prop, Watch} from "vue-property-decorator";

@Component({
    components: {
        ripple
    }
})
export default class Toggle extends Vue {

    @Prop({}) toggleState:boolean;

    isActive = false;

    mounted(){
        this.isActive = this.toggleState;
    }

    toggle(){
        this.isActive = ! this.isActive;
        this.$emit("toggled", this.isActive);
    }

    @Watch('toggleState')
    changeToggleState(to, from){
        this.isActive = this.toggleState;
    }
}

